
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".639","y":"5.472","width":"21.722","height":"21.722","rx":"4.472","stroke":"currentColor","stroke-width":"1.278"}}),_c('path',{attrs:{"d":"M17.161 17.078H12.51v4.574h-2.147v-4.574h-4.65v-2.02h4.65v-4.6h2.147v4.6h4.651v2.02z","fill":"currentColor"}})])
          )
        }
      }
    